import React, { useState } from "react";
import { FiArrowLeft } from "react-icons/fi";
import styles from "./StaffTable.module.css";

import Warehouse from "./PositionPanel/Warehouse";
import Sales from "./PositionPanel/Sales";
import Contractors from "./PositionPanel/Contractors";
import Reports from "./PositionPanel/Reports";
import Misc from "./PositionPanel/Misc";

const AddPositionPanel = ({ onClose, positionId, positionTitle }) => {
  const [activeTab, setActiveTab] = useState("Warehouse");

  const tabs = [
    { id: "Warehouse", label: "Склад" },
    { id: "Sales", label: "Реализация" },
    { id: "Contractors", label: "Контрагенты" },
    { id: "Reports", label: "Отчёты ККМ" },
    { id: "Misc", label: "Прочее" },
  ];

  const renderContent = () => {
    switch (activeTab) {
      case "Warehouse":
        return <Warehouse roleId={positionId} roleTitle={positionTitle} />; 
      case "Sales":
        return <Sales roleId={positionId} roleTitle={positionTitle} />;
      case "Contractors":
        return <Contractors roleId={positionId} roleTitle={positionTitle} />;
      case "Reports":
        return <Reports roleId={positionId} roleTitle={positionTitle} />;
      case "Misc":
        return <Misc roleId={positionId} roleTitle={positionTitle} />;
      default:
        return null;
    }
  };

  return (
    <div className={styles.workspace}>
      <div className={styles.block}>
        <button className={styles.closeButton} onClick={onClose}>
          <FiArrowLeft size={24} />
        </button>
        <div className={styles.header}>
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`${styles.tabButton} ${
                activeTab === tab.id ? styles.active : ""
              }`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>
      <div className={styles.panelContent}>{renderContent()}</div>
    </div>
  );
};

export default AddPositionPanel;
